import { useEffect, useState } from 'react';
import Tab1UsersPermissions from '../Tab1UsersPermissions/Tab1UsersPermissions';
import { Itab } from '../../../../types/global';
import { IgetBackofficeConfigurationResponse } from '../../../../types/configuration.types';
import './BackofficeConfigurationTabs.scss';

const BackofficeConfigurationTabs = ({
  handleTabSelectionCallback,
  updateDataCallback,
  permissionsData
}: {
  handleTabSelectionCallback: (newTabData: Itab) => void;
  updateDataCallback?: () => void;
  permissionsData?: IgetBackofficeConfigurationResponse;
}) => {
  const [currentTab, setCurrentTab] = useState(0);
  const switchTab = (tabId: number) => currentTab !== tabId && setCurrentTab(tabId);

  const backofficeConfigurationTabsList = [
    {
      tabId: 0,
      action: () => switchTab(0),
      tabName: 'Usuarios',
      tabComponent: <Tab1UsersPermissions permissionsData={permissionsData} updateDataCallback={updateDataCallback} />
    }
  ];

  useEffect(() => {
    const currentTabData = backofficeConfigurationTabsList[currentTab];
    handleTabSelectionCallback(currentTabData);
  }, [currentTab, permissionsData]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="backofficeConfigurationTabs">
      {backofficeConfigurationTabsList.map(tab => {
        const tabClassname = `configurationTab ${tab?.tabId === currentTab ? 'active' : ''}`;
        return (
          <div className={tabClassname} key={`tab${tab.tabId}`} onClick={tab.action}>
            <div className="tabName">{tab.tabName}</div>
          </div>
        );
      })}
    </div>
  );
};

export default BackofficeConfigurationTabs;
